import { Skeleton, SkeletonGroup } from '@shared/components/Skeleton';
import { useFormById } from './hooks/useFormById';
import React, { useMemo } from 'react';
import { STEP_MINIMUM_HEIGHT } from '../presentational/steps/consts';
import { BasicForm } from '../functional/basic';
import { FormType } from '@graphql/generated';
import { RegistrationForm } from '../functional/registration/RegistrationForm';
import { EventFormValues } from '../presentational/hooks/useEventFormState';

const EventFormSkeleton = () => {
  return (
    <Skeleton
      width="100%"
      height={STEP_MINIMUM_HEIGHT}
    />
  );
};

type EventFormProps = {
  formId: string;
  onComplete?: (values: EventFormValues) => void;
};

export const EventForm = (props: EventFormProps) => {
  const { formId, onComplete } = props;
  const { data, loading } = useFormById(formId);

  const content = useMemo(() => {
    if (!data) {
      return null;
    }

    switch (data.type) {
      case FormType.REGISTRATION: {
        return (
          <RegistrationForm
            formData={{ ...data, type: FormType.REGISTRATION }}
            onComplete={onComplete}
          />
        );
      }
      case FormType.SURVEY:
      case FormType.OTHER:
      default: {
        return (
          <BasicForm
            formData={{ ...data, type: FormType.SURVEY }}
            onComplete={onComplete}
          />
        );
      }
    }
  }, [data, onComplete]);

  return (
    <SkeletonGroup
      isReady={!loading}
      placeholder={EventFormSkeleton}
    >
      {content}
    </SkeletonGroup>
  );
};
